import toast from 'react-hot-toast'

import { showApiError, useMutation } from '@fv/client-core'
import type { ClientAddressLookupResult } from '@fv/client-types'

import { shipperFetch } from '@/utils/shipperFetch'

import { addressMapper } from './addressFuncs'
import { useAddressBookCacheModifier } from './cache-modifiers'
import type { AddressBookListConfig, FormAddress } from './types'
import { normalizeAddressResult } from './utils'

async function updateAddress(address: FormAddress & { id: string }) {
  return shipperFetch<ClientAddressLookupResult>(`/addresses/${address.id}`, {
    body: addressMapper.formAddressToDTO(address),
    method: 'PUT',
  })
}

export function useUpdateAddress(config: AddressBookListConfig) {
  const { replaceInCache } = useAddressBookCacheModifier(config)

  return useMutation(updateAddress, {
    onSettled: (address, error, variables) => {
      if (error) return showApiError('Unable to update address', error)

      replaceInCache(normalizeAddressResult(address))
      toast.success('Address updated successfully.')
    },
  })
}
